import {FC} from 'react'
import {LayoutProps} from './Layout.types'

export const DefaultLayout: FC<LayoutProps> = ({
  children,
  bgColor,
  lgColumns,
}) => (
  <main
    className={`min-w-full h-screen ${bgColor} grid grid-cols-1 ${lgColumns}`}
  >
    {children}
  </main>
)
